export const INWARDS_SUPPLIES_HEADERS: any[] = [
  {
    label: "",
    value: "",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "INVOICE DATE",
    value: "invoice_date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "SUPPLIER NAME & GST",
    value: "seller_name",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "INVOICE NUMBER",
    value: "invoice_number",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "DOCUMENT TYPE",
    value: "document_type",
    defaultChecked: true,
    checked: true,
  },

  {
    label: "GSTR 2A",
    value: "gstr2a",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "GSTR 2B",
    value: "gstr2b",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "MONTH IN GSTR 3B",
    value: "gstr3b_month",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "RECLAIM",
    value: "reclaim",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "WHETHER ELIGIBLE",
    value: "whether_eligible",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "CLASSIFICATION",
    value: "classification",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "SELLER TYPE",
    value: "seller_type",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "COMPOSITION DEALER",
    value: "purchase_from_composition_dealer",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "IGST AMOUNT",
    value: "total_igst_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "SGST AMOUNT",
    value: "total_sgst_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "CGST AMOUNT",
    value: "total_cgst_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "ITC AMOUNT",
    value: "total_itc_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "TOTAL INVOICE",
    value: "total_invoice_value",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "TAXABLE VALUE",
    value: "total_taxable_value",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "TABLE & CATEGORY",
    value: "gst_exemption",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "REVERSE CHARGE",
    value: "reverse_charge",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "GSTR3B Type",
    value: "gstr3b_type_arr",
    defaultChecked: true,
    checked: true,
  },
];

export const INWARDS_ITEM_TABLE_HEADERS: any[] = [
  {
    label: "NATURE OF EXPENSE",
    value: "nature_of_expense",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "DESC AS PER BILL",
    value: "desc_as_per_bill",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "SKU CODE",
    value: "sku_code",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "HSN/SAC CODE",
    value: "hsn_sac_code",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "UNIT",
    value: "unit",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "RATE",
    value: "rate",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "QUANTITY",
    value: "quantity",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "AMOUNT",
    value: "amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "DISCOUNT",
    value: "discount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "TAXABLE VALUE",
    value: "taxable_value",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "GST PERCENTAGE",
    value: "gst_per",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "IGST AMOUNT",
    value: "igst_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "SGST AMOUNT",
    value: "sgst_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "CGST AMOUNT",
    value: "cgst_amount",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "TOTAL VALUE",
    value: "total_value",
    defaultChecked: true,
    checked: true,
  },
];
